/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, OnInit,
  ViewChild
} from '@angular/core';

import {EmpZoneDependency} from '../../form-generator.interfaces';
import {AbstractField} from '../abstract-field';

/**
 * A checkbox type of field for boolean values.
 */
@Component({
  selector: 'gp-form-field-boolean',
  styleUrls: ['./boolean-field.component.scss'],
  template: `
    <div class="three-states-checkbox">
      <label for="switch" class="three-states-checkbox__label">{{ descriptor?.transId | translate }}
        <span class="required" *ngIf="descriptor?.isRequired">*</span>
      </label>
      <div class="three-states-checkbox__spinner">
        <i class="fa fa-light fa-spinner fa-spin"
           *ngIf="descriptor?.defaultValue"
           attr.mvel-alias="{{descriptor?.transId}}"></i>
      </div>
      <div class="form-control three-states-checkbox__wrapper"
           [style.opacity]="readOnly ? 0.5: 1"
           [style.cursor]="readOnly ? 'not-allowed' : null"
           (click)="toggle(readOnly)"
           [tooltip]="tooltip | translate"
           placement="bottom"
           container="body">
        <input name="switch"
               type="checkbox"
               [attr.test-id]="descriptor.zoneID"
               #hiddenInput
               [formControl]="control"
               [(ngModel)]="value.value">
        <span class="switch-bar"></span>
        <span [ngClass]="{
                'true': value.value === true,
                'false': value.value === false,
                'unspecified': isUnspecified
               }"></span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BooleanFieldComponent extends AbstractField implements OnInit, AfterContentInit {

  @ViewChild('hiddenInput', {static: true})
  private hiddenInput: ElementRef;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.bindDependencyTriggered();
  }

  protected afterDependencyHandled(dependency: EmpZoneDependency) {
    this.cd.markForCheck();
  }

  public get isUnspecified(): boolean {
    return this.value.value !== false && this.value.value !== true;
  }

  public get tooltip(): string {
    if (this.isUnspecified) {
      return 'COMMON.unspecified';
    } else {
      return this.value.value ? 'COMMON.yes' : 'COMMON.no';
    }
  }

  public toggle(isDisabled: boolean): void {
    if (!isDisabled) {
      this.value.value = !this.value.value;
      this.control.patchValue(this.value.value);
      this.control.markAsDirty();
    }
  }

  public ngAfterContentInit(): void {
    if (this.hasMvelValue()) {
      this.value.value = this.hiddenInput.nativeElement.value === 'on';
    }
  }

  private hasMvelValue(): boolean {
    return this.descriptor.defaultValue && this.value.value === null;
  }

}
